import styled from 'styled-components';
import { themeGet, getTextColor, getMediaQuery } from '@magalu/stereo-ui-styles';
import Text from '../../atoms/Text';
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > ul {
    width: 100%;
    margin-top: 20px;
  }

  ${getMediaQuery('large')} {
    flex-direction: row;
    width: 100%;

    > ul {
      width: ${({
  showScoreDesc
}) => !showScoreDesc ? '100%' : '50%'};
    }
  }
`;
export const Main = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${getMediaQuery('large')} {
    flex-direction: column-reverse;
    flex: 1;
  }
`;
export const Content = styled.div`
  margin-left: 8px;

  > div {
    margin-left: -4px;
  }
`;
export const Line = styled.li`
  display: grid;
  grid-template-columns: 2fr 2fr auto;
  align-items: center;
  grid-gap: 8px;

  & > p:first-child {
    font-size: ${themeGet('fontSizes.1')}px;
    line-height: ${themeGet('lineHeights.display')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & > p:last-child {
    font-weight: ${props => themeGet('fontWeights.bold')(props)};
  }

  ${getMediaQuery('large')} {
    grid-template-columns: 1fr 2fr auto;
  }
`;
export const Score = styled(Text)`
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  font-size: ${props => themeGet('fontSizes.7')(props)}px;

  & > span {
    display: none;
  }

  ${getMediaQuery('large')} {
    line-height: ${props => themeGet('lineHeights.fontSize')(props)};

    & > span {
      display: inline-block;
    }
  }
`;
export const Description = styled(Text)`
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  color: ${props => getTextColor('light')(props)};

  ${getMediaQuery('large')} {
    margin-top: ${props => themeGet('space.3')(props)}px;
  }
`;